module.exports = __webpack_public_path__ + "static/media/left-arrow.bd0e3df3.svg";